var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignedToMe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_9346)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4.5C9.5 5.42826 9.13125 6.3185 8.47487 6.97487C7.8185 7.63125 6.92826 8 6 8C5.07174 8 4.1815 7.63125 3.52513 6.97487C2.86875 6.3185 2.5 5.42826 2.5 4.5C2.5 3.57174 2.86875 2.6815 3.52513 2.02513C4.1815 1.36875 5.07174 1 6 1C6.92826 1 7.8185 1.36875 8.47487 2.02513C9.13125 2.6815 9.5 3.57174 9.5 4.5ZM8.5 4.5C8.5 3.83696 8.23661 3.20107 7.76777 2.73223C7.29893 2.26339 6.66304 2 6 2C5.33696 2 4.70107 2.26339 4.23223 2.73223C3.76339 3.20107 3.5 3.83696 3.5 4.5C3.5 5.16304 3.76339 5.79893 4.23223 6.26777C4.70107 6.73661 5.33696 7 6 7C6.66304 7 7.29893 6.73661 7.76777 6.26777C8.23661 5.79893 8.5 5.16304 8.5 4.5ZM1.75 9C1.28587 9 0.840752 9.18437 0.512563 9.51256C0.184375 9.84075 0 10.2859 0 10.75V11C0 12.1965 0.7615 13.2085 1.8425 13.8965C2.9295 14.5885 4.401 15 6 15C7.599 15 9.07 14.5885 10.1575 13.8965C11.2385 13.2085 12 12.1965 12 11V10.75C12 10.2859 11.8156 9.84075 11.4874 9.51256C11.1592 9.18437 10.7141 9 10.25 9H1.75ZM1 10.75C1 10.5511 1.07902 10.3603 1.21967 10.2197C1.36032 10.079 1.55109 10 1.75 10H10.25C10.4489 10 10.6397 10.079 10.7803 10.2197C10.921 10.3603 11 10.5511 11 10.75V11C11 11.7365 10.53 12.4745 9.6205 13.053C8.717 13.628 7.4385 14 6 14C4.5615 14 3.283 13.628 2.3795 13.053C1.4695 12.475 1 11.736 1 11V10.75Z",
    fill: "#1B3E61",
    stroke: "#1B3E61",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_9346"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignedToMe);
export default __webpack_public_path__ + "static/media/assignedToMe.d1a0f1f386c886c962d13e39ea17c2f5.svg";
export { ForwardRef as ReactComponent };